(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dantamanjari-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dm-story-gallery')) {
 class DMStoryGallery extends HTMLElement {
  connectedCallback() {
   if(this.active)return;this.active=true;
   this.onClick=e=>{
    const trigger=e.target.closest('[data-gallery-open]');
    if(trigger&&this.contains(trigger)){
     if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)return;
     const dialog=document.getElementById(trigger.getAttribute('aria-controls'));
     if(!dialog||!this.contains(dialog)||typeof dialog.showModal!=='function')return;
     e.preventDefault();dialog.galleryOpener=trigger;this.showPhoto(dialog,Number(trigger.dataset.photoIndex));if(!dialog.open)dialog.showModal();return;
    }
    const action=e.target.closest('[data-gallery-action]');
    if(action){const dialog=action.closest('dialog');if(!dialog)return;const index=Number(dialog.dataset.currentPhoto)||0;
     if(action.dataset.galleryAction==='close')dialog.close();
     else this.showPhoto(dialog,index+(action.dataset.galleryAction==='next'?1:-1));return;
    }
    if(e.target.matches('dialog.dm-story__lightbox')){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}
   };
   this.onKey=e=>{const dialog=e.target.closest('dialog[open]');if(!dialog)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.showPhoto(dialog,(Number(dialog.dataset.currentPhoto)||0)+(e.key==='ArrowRight'?1:-1));}};
   this.onClose=e=>{if(e.target.matches('dialog.dm-story__lightbox')){const opener=e.target.galleryOpener;if(opener?.isConnected)opener.focus({preventScroll:true});e.target.galleryOpener=null;}};
   this.onToggle=e=>{if(!e.target.matches('.dm-story__details'))return;const details=e.target;details.closest('.dm-story__chapter').classList.toggle('is-expanded',details.open);if(details.open&&this.hasAttribute('data-one-open'))this.querySelectorAll('.dm-story__details[open]').forEach(other=>{if(other!==details)other.open=false;});};
   this.addEventListener('click',this.onClick);this.addEventListener('keydown',this.onKey);
   this.dialogs=Array.from(this.querySelectorAll('dialog'));
   this.dialogs.forEach(dialog=>{dialog.addEventListener('close',this.onClose);this.showPhoto(dialog,0);});
   this.details=Array.from(this.querySelectorAll('.dm-story__details'));
   this.details.forEach(details=>{details.addEventListener('toggle',this.onToggle);details.closest('.dm-story__chapter').classList.toggle('is-expanded',details.open);});
  }
  disconnectedCallback(){this.active=false;this.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKey);this.dialogs?.forEach(dialog=>dialog.removeEventListener('close',this.onClose));this.details?.forEach(details=>details.removeEventListener('toggle',this.onToggle));}
  showPhoto(dialog,index){const slides=Array.from(dialog.querySelectorAll('[data-gallery-slide]'));if(!slides.length)return;index=((index%slides.length)+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);dialog.dataset.currentPhoto=String(index);dialog.querySelector('[data-gallery-counter]').textContent=(index+1)+' / '+slides.length;dialog.querySelectorAll('[data-gallery-action="next"],[data-gallery-action="previous"]').forEach(button=>button.disabled=slides.length<2);}
 }
 customElements.define('dm-story-gallery',DMStoryGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers-and-rewards"] && !Shopify.designMode) return;
  try {
    
(function () {
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Cart drawer guard ----------
     Some themes/apps open the cart drawer whenever the cart changes.
     While the bundle builder is syncing we close it again, unless it was
     already open or the customer just clicked the cart icon themselves. */
    var guard = { busy: 0, until: 0, intent: 0, userOpen: false, bound: false, timer: null };
    var HOLD_MS = 10000;   /* keep blocking this long after the last bundle change */

    function drawerEl() { return document.querySelector('cart-drawer'); }

    function guardActive() {
        return !guard.userOpen &&
            (guard.busy > 0 || Date.now() < guard.until) &&
            (Date.now() - guard.intent > 1500);
    }

    /* Fully hide the drawer + its dark overlay while the guard is on */
    function setHidden(on) {
        var d = drawerEl();
        if (!d) return;
        if (on) {
        d.style.setProperty('visibility', 'hidden', 'important');
        d.style.setProperty('pointer-events', 'none', 'important');
        } else {
        d.style.removeProperty('visibility');
        d.style.removeProperty('pointer-events');
        }
    }

    function forceClose() {
        var d = drawerEl();
        if (!d) return;
        if (d.classList.contains('active')) {
        try { if (typeof d.close === 'function') d.close(); } catch (e) {}   /* theme's own close */
        }
        d.classList.remove('active', 'animate');
        document.body.classList.remove('overflow-hidden');
        try { if (typeof removeTrapFocus === 'function') removeTrapFocus(); } catch (e) {}
        setHidden(true);
    }

    function bindGuard() {
    var d = drawerEl();
    if (d && !d.__dmGuard) {
        d.__dmGuard = true;

        /* 1. Block the theme's open() only while we are syncing */
        if (typeof d.open === 'function') {
        var origOpen = d.open;
        d.open = function () {
            if (guardActive()) return;
            setHidden(false);              /* always undo our inline hiding on a real open */
            return origOpen.apply(this, arguments);
        };
        }

        /* 2. A close (close icon, overlay click, ESC) must reset the guard and finish cleanly */
        if (typeof d.close === 'function') {
            var origClose = d.close;
            d.close = function () {
                guard.userOpen = false;
                guard.intent = 0;
                var result = origClose.apply(this, arguments);
                d.classList.remove('active');
                document.body.classList.remove('overflow-hidden');
                setTimeout(function () {
                    if (d.classList.contains('active')) return;
                    /* force Safari to repaint */
                    d.style.setProperty('display', 'none', 'important');
                    void d.offsetHeight;
                    d.style.removeProperty('display');
                    setHidden(true);
                }, 350);
                return result;
            };
        }

        /* 3. Fallback: undo any class-based opening we did not allow */
        if (window.MutationObserver) {
        new MutationObserver(function () {
            var isOpen = d.classList.contains('active');
            if (!isOpen) { guard.userOpen = false; return; }
            if (Date.now() - guard.intent <= 1500) {
            guard.userOpen = true;
            setHidden(false);            /* user-initiated open: make sure we are not hiding it */
            return;
            }
            if (guardActive()) forceClose();
        }).observe(d, { attributes: true, attributeFilter: ['class'] });
        }
    }

    if (!guard.bound) {
        guard.bound = true;
        document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('#cart-icon-bubble, a[href$="/cart"], [data-cart-drawer-trigger]')) {
            guard.intent = Date.now();
            setHidden(false);
        }
        }, true);
    }
    }

  function guardStart() {
    bindGuard();
    guard.busy++;
  }

  function guardEnd() {
    guard.busy = Math.max(0, guard.busy - 1);
    guard.until = Date.now() + HOLD_MS;
    if (guardActive()) forceClose();
    setTimeout(function () { if (guardActive()) forceClose(); }, 300);
    setTimeout(function () { if (guardActive()) forceClose(); }, 900);

    /* lift the hiding once the hold time has passed */
    clearTimeout(guard.timer);
    guard.timer = setTimeout(function () {
      if (guard.busy === 0) setHidden(false);
    }, HOLD_MS + 200);
  }

  function jsonFetch(url, body) {
    var opts = { cache: 'no-store', headers: { 'Accept': 'application/json', 'X-DM-Bundle': '1' } };
    if (body) {
        opts.method = 'POST';
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (res) {
        if (!res.ok) throw new Error('Request failed: ' + url);
        return res.json();
    });
  }

  function isGiftLine(item) {
    var pr = item && item.properties;
    return !!(pr && (pr._free_gift || pr._cart_reward_gift || pr._free_toothbrush));
  }

  /* Silently refresh cart drawer + header cart count */
  function refreshDrawer() {
    return fetch(shopRoot + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (sections) {
        try {
          if (sections['cart-drawer']) {
            var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var src = doc.querySelector('.drawer__inner');
            var container = document.getElementById('CartDrawer');
            if (src && container) {
              var target = container.querySelector('.drawer__inner') || container;
              target.innerHTML = src.innerHTML;
              var sw = doc.querySelector('cart-drawer');
              var tw = document.querySelector('cart-drawer');
              if (sw && tw) tw.classList.toggle('is-empty', sw.classList.contains('is-empty'));
            }
          }
          if (sections['cart-icon-bubble']) {
            var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var nb = bdoc.querySelector('.shopify-section');
            var cb = document.getElementById('cart-icon-bubble');
            if (nb && cb) cb.innerHTML = nb.innerHTML;
          }
          if (window.SenseLoaderLock && window.SenseLoaderLock.sync) window.SenseLoaderLock.sync();
        } catch (e) { console.error('[offers-and-rewards] drawer refresh failed', e); }
        /* Intentionally NOT publishing cartUpdate / cart events: some themes open the drawer on them. */
      })
      .catch(function () {});
  }

  (function patchFetchOnce() {
        if (window.__dmFetchPatched) return;
        window.__dmFetchPatched = true;
        var cartRe = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
        var origFetch = window.fetch;
        window.fetch = function (input, init) {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var own = false;
            try {
            var h = (init && init.headers) || (input && input.headers);
            if (h) own = (typeof h.get === 'function' ? h.get('X-DM-Bundle') : h['X-DM-Bundle']) === '1';
            } catch (e) {}
            var p = origFetch.apply(this, arguments);
            if (!own && cartRe.test(url)) {
            p.then(function () { window.dispatchEvent(new CustomEvent('dm:cart-changed')); }).catch(function () {});
            }
            return p;
        };
    })();

  function initBundle(el) {
    if (el.dataset.dmReady) return;
    el.dataset.dmReady = 'true';

    var giftQty = parseInt(el.dataset.giftQty, 10) || 2;
    var shipQty = parseInt(el.dataset.shipQty, 10) || 3;
    var kidsGift = el.dataset.kidsGift === 'true';
    var giftVariant = el.dataset.giftVariant;
    var discountCode = el.dataset.discountCode;
    var symbol = el.dataset.currencySymbol || '';
    var one = el.dataset.labelOne || 'bottle';
    var many = el.dataset.labelMany || 'bottles';

    var cards = {};      /* variantId -> { value, minus, plus, price, kids } */
    var qty = {};        /* what the UI shows */
    var server = {};     /* what the cart holds */
    var cartCount = 0;
    var queue = Promise.resolve();
    var timer = null;

    var totalQty = el.querySelector('[data-total-qty]');
    var totalPrice = el.querySelector('[data-total-price]');
    var rewardMessage = el.querySelector('[data-reward-message]');
    var rewardProgress = el.querySelector('[data-reward-progress]');
    var cartButton = el.querySelector('[data-cart-button]');
    var m1 = el.querySelector('[data-milestone="1"]');
    var m2 = el.querySelector('[data-milestone="2"]');
    var m3 = el.querySelector('[data-milestone="3"]');

    el.querySelectorAll('.dm-product').forEach(function (card) {
      var id = card.dataset.variantId;
      if (!id) return;
      cards[id] = {
        value: card.querySelector('.dm-qty-value'),
        minus: card.querySelector('.dm-minus'),
        plus: card.querySelector('.dm-plus'),
        price: parseInt(card.dataset.price, 10) || 0,
        kids: card.dataset.kids === 'true'
      };
      qty[id] = 0;
      server[id] = 0;
    });

    function formatMoney(cents) {
      var amount = (cents || 0) / 100;
      var hasDecimals = Math.round(amount) !== amount;
      return symbol + amount.toLocaleString('en-IN', {
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2
      });
    }

    function fmt(str, n) {
      return (str || '')
        .replace(/\[n\]/g, n)
        .replace(/\[bottles\]/g, n === 1 ? one : many)
        .replace(/\[gift\]/g, giftQty)
        .replace(/\[ship\]/g, shipQty);
    }

    function sumOf(map, onlyKids) {
      var t = 0;
      Object.keys(cards).forEach(function (id) {
        if (onlyKids && !cards[id].kids) return;
        t += map[id] || 0;
      });
      return t;
    }

    /* Gift rule: enough bottles OR at least 1 Kids bottle */
    function giftUnlocked(total, kids) {
      return total >= giftQty || (kidsGift && kids >= 1);
    }

    function render() {
      var total = 0, price = 0;
      Object.keys(cards).forEach(function (id) {
        var c = cards[id];
        var q = qty[id] || 0;
        c.value.textContent = q;
        c.minus.disabled = q === 0;
        total += q;
        price += q * c.price;
      });
      var kids = sumOf(qty, true);
      var giftOn = giftUnlocked(total, kids);

      totalQty.textContent = total + ' ' + (total === 1 ? one : many);
      totalPrice.textContent = formatMoney(price);
      cartButton.disabled = !(total > 0 || cartCount > 0);

      m1.classList.toggle('active', total >= 1);
      m2.classList.toggle('active', giftOn);
      m3.classList.toggle('active', total >= shipQty);

      var pct = 0;
      if (total >= shipQty) {
        pct = 100;
      } else if (total >= giftQty) {
        pct = 50 + (shipQty > giftQty ? ((total - giftQty) / (shipQty - giftQty)) * 50 : 0);
      } else if (total >= 1 && giftQty > 1) {
        pct = ((total - 1) / (giftQty - 1)) * 50;
      }
      if (giftOn && pct < 50) pct = 50;
      rewardProgress.style.width = Math.min(100, pct) + '%';

      var msg;
      if (!giftOn) {
        msg = fmt(total === 0 ? el.dataset.msgStart : el.dataset.msgGift, giftQty - total);
      } else if (total < shipQty) {
        msg = fmt(el.dataset.msgShip, shipQty - total);
      } else {
        msg = fmt(el.dataset.msgDone, 0);
      }
      rewardMessage.textContent = msg;
    }

    /* Read cart -> update UI numbers */
    function syncFromCart() {
      return jsonFetch(shopRoot + 'cart.js').then(function (cart) {
        Object.keys(server).forEach(function (id) { server[id] = 0; });
        (cart.items || []).forEach(function (item) {
          var id = String(item.variant_id);
          if (id in server && !isGiftLine(item)) server[id] += item.quantity;
        });
        Object.keys(server).forEach(function (id) { qty[id] = server[id]; });
        cartCount = cart.item_count || 0;
        render();
        return cart;
      });
    }

    /* Add / remove the free gift line to match the unlock rule */
    function syncGift(cart) {
      if (!giftVariant) return Promise.resolve();
      var giftLine = null;
      (cart.items || []).forEach(function (item) {
        if (String(item.variant_id) === String(giftVariant) && isGiftLine(item)) giftLine = item;
      });
      var wants = giftUnlocked(sumOf(server, false), sumOf(server, true));

      if (wants && !giftLine) {
        return jsonFetch(shopRoot + 'cart/add.js', {
          items: [{ id: parseInt(giftVariant, 10), quantity: 1, properties: { '_free_gift': 'true' } }]
        }).catch(function () {});
      }
      if (!wants && giftLine) {
        return jsonFetch(shopRoot + 'cart/change.js', { id: giftLine.key, quantity: 0 }).catch(function () {});
      }
      return Promise.resolve();
    }

    /* Send every pending quantity change in ONE request, then refresh once */
    function flush() {
      var updates = {}, any = false;
      Object.keys(qty).forEach(function (id) {
        if (qty[id] !== server[id]) { updates[id] = qty[id]; any = true; }
      });
      if (!any) return Promise.resolve();

      guardStart();
      return jsonFetch(shopRoot + 'cart/update.js', { updates: updates })
        .then(function (cart) {
          Object.keys(updates).forEach(function (id) { server[id] = updates[id]; });
          cartCount = cart.item_count || 0;
          return syncGift(cart);
        })
        .then(function () { return refreshDrawer(); })
        .then(function () { render(); guardEnd(); })
        .catch(function (err) { guardEnd(); throw err; });
    }

    function runFlush() {
      queue = queue.then(flush).catch(function () {
        return syncFromCart().then(refreshDrawer);
      });
      return queue;
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(runFlush, 300);   /* rapid clicks are merged */
    }

    function change(id, delta) {
      var cur = qty[id] || 0;
      var next = Math.max(0, cur + delta);
      if (next === cur) return;
      qty[id] = next;
      render();   /* instant UI */
      schedule();
    }

    Object.keys(cards).forEach(function (id) {
      cards[id].minus.addEventListener('click', function () { change(id, -1); });
      cards[id].plus.addEventListener('click', function () { change(id, 1); });
    });

    var cartLabel = cartButton.querySelector('[data-cart-label]');
    var cartLabelOriginal = cartLabel.textContent;

    function resetButton() {
      cartLabel.textContent = cartLabelOriginal;
      render();   /* also re-evaluates disabled state from current quantities */
    }

    cartButton.addEventListener('click', function () {
      cartButton.disabled = true;
      cartLabel.textContent = 'Please wait...';
      clearTimeout(timer);

      runFlush().then(function () {
        var target = '/checkout';
        if (sumOf(server, false) >= shipQty && discountCode) {
          window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(target);
        } else {
          window.location.href = target;
        }
      }).catch(function () {
        resetButton();
      });
    });

    /* keep numbers in sync when cart is changed elsewhere (drawer, other upsell) */
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'dm-bundle') return;
        queue = queue.then(syncFromCart).catch(function () {});
      });
    }
    var resyncTimer;
    function externalSync() {
    clearTimeout(resyncTimer);
    resyncTimer = setTimeout(function () {
        /* don't overwrite clicks that haven't been sent yet */
        var pending = Object.keys(qty).some(function (id) { return qty[id] !== server[id]; });
        if (pending) return;
        queue = queue.then(syncFromCart).catch(function () {});
    }, 200);
    }
    window.addEventListener('dm:cart-changed', externalSync);

    window.addEventListener('pageshow', function (e) {
      resetButton();                 /* always reset the label when the page is shown */
      if (e.persisted) externalSync();   /* Safari/Chrome back-forward cache */
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        resetButton();
        externalSync();
      }
    });

    bindGuard();
    render();
    syncFromCart().catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('[data-dm-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
